var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_timeout") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    transform: "translate(-589.000000, -112.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_timeout_02",
    transform: "translate(592.000000, 115.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    cx: 15,
    cy: 15,
    rx: 15,
    ry: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,13.8395784 L14,5.87243867 C14,5.31934155 14.4438648,4.87096774 15,4.87096774 C15.5522847,4.87096774 16,5.32837702 16,5.87243867 L16,13.1986897 L16,13.1986897 L19.3256091,9.87308056 C19.7146781,9.48401161 20.3439406,9.48246873 20.7371875,9.87571569 C21.1277118,10.26624 21.134283,10.8928338 20.7398227,11.2872941 L16.9486523,15.0784645 C16.9822454,15.2191034 17,15.3656097 17,15.516129 C17,16.5850673 16.1045695,17.4516129 15,17.4516129 C13.8954305,17.4516129 13,16.5850673 13,15.516129 C13,14.7997268 13.4021986,14.1742327 14,13.8395784 Z",
    id: "Rectangle-5213",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9090909,28.1901969 C29.9090909,28.5626779 29.5419069,28.9442815 29.1298701,28.9442815 L19.7792208,28.9442815 C19.367184,28.9442815 19,28.5629354 19,28.1901969 L19,19.1411814 C19,18.7687004 19.367184,18.3870968 19.7792208,18.3870968 L29.1298701,18.3870968 C29.5419069,18.3870968 29.9090909,18.7684429 29.9090909,19.1411814 L29.9090909,28.1901969 L29.9090909,28.1901969 Z",
    id: "Shape",
    fill: "#A52A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6363636,20.8504399 L23.6363636,20.8504399 L23.6363636,26.6568915 L21.6363636,26.6568915 L21.6363636,20.8504399 Z M25.6363636,20.8504399 L27.6363636,20.8504399 L27.6363636,26.6568915 L25.6363636,26.6568915 L25.6363636,20.8504399 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeout);
export default __webpack_public_path__ + "static/media/timeout.0a9521b987af4365f8f802f31e9a51af.svg";
export { ForwardRef as ReactComponent };